import { useState } from 'react';
import styles from './style.module.css';

const STEPS = {
  TYPE: 'type',
  NEW_BASE: 'new-base',
  BULK: 'bulk',
};

const ImportFlowModal = ({
  onClose,
  onContinueNewBase,
  onContinueBulk,
  newBaseExample,
  bulkExample,
  showBulkOption = false,
}) => {
  const [step, setStep] = useState(STEPS.TYPE);
  const [importType, setImportType] = useState('new-base');

  const close = () => onClose();

  const handleTypeContinue = () => {
    if (importType === 'bulk' && showBulkOption) {
      setStep(STEPS.BULK);
      return;
    }
    setStep(STEPS.NEW_BASE);
  };

  const handleTemplateContinue = () => {
    if (step === STEPS.BULK) {
      onContinueBulk();
      return;
    }
    onContinueNewBase();
  };

  if (step === STEPS.TYPE) {
    return (
      <div className={styles.overlay} onClick={close} role="presentation">
        <div
          className={styles.card}
          role="dialog"
          aria-labelledby="import-flow-title"
          onClick={(event) => event.stopPropagation()}
        >
          <header className={styles.header}>
            <h2 id="import-flow-title">Upload de Arquivo</h2>
            <button type="button" className={styles.close} onClick={close} aria-label="Fechar">
              X
            </button>
          </header>
          <p className={styles.description}>
            Escolha se deseja importar uma nova base ou atualizar uma base existente
          </p>
          <div className={styles.radios} role="radiogroup" aria-label="Tipo de importação">
            <label className={styles.radioItem}>
              <input
                type="radio"
                name="import-type"
                value="new-base"
                checked={importType === 'new-base'}
                onChange={() => setImportType('new-base')}
              />
              <span>Importar nova base</span>
            </label>
            {showBulkOption && (
              <label className={styles.radioItem}>
                <input
                  type="radio"
                  name="import-type"
                  value="bulk"
                  checked={importType === 'bulk'}
                  onChange={() => setImportType('bulk')}
                />
                <span>Atualizar registros em massa</span>
              </label>
            )}
          </div>
          <footer className={styles.footer}>
            <button type="button" className={styles.btnGhost} onClick={close}>
              Cancelar
            </button>
            <button type="button" className={styles.btnPrimary} onClick={handleTypeContinue}>
              Continuar
            </button>
          </footer>
        </div>
      </div>
    );
  }

  const isBulk = step === STEPS.BULK;

  return (
    <div className={styles.overlay} onClick={close} role="presentation">
      <div
        className={styles.card}
        role="dialog"
        aria-labelledby="import-template-title"
        onClick={(event) => event.stopPropagation()}
      >
        <header className={styles.header}>
          <h2 id="import-template-title">
            {isBulk ? 'Atualizar registros em massa' : 'Importar nova base'}
          </h2>
          <button type="button" className={styles.close} onClick={close} aria-label="Fechar">
            X
          </button>
        </header>
        <p className={styles.description}>
          {isBulk
            ? 'Faça a importação utilizando o arquivo padrão. É importante não adicionar ou remover a coluna e manter o nome correto da coluna.'
            : 'Faça a importação utilizando o arquivo padrão. É importante não adicionar ou remover colunas e manter o nome correto de cada coluna.'}
        </p>
        <a
          className={styles.downloadLink}
          href={isBulk ? bulkExample : newBaseExample}
          download={isBulk ? 'arquivo-padrao-pagamento-indireto.xlsx' : 'arquivo-padrao-nova-base.xlsx'}
          rel="noreferrer"
        >
          Baixar arquivo padrão
          <span aria-hidden="true">↓</span>
        </a>
        <footer className={styles.footer}>
          <button type="button" className={styles.btnGhost} onClick={close}>
            Cancelar
          </button>
          <button type="button" className={styles.btnPrimary} onClick={handleTemplateContinue}>
            Continuar
          </button>
        </footer>
      </div>
    </div>
  );
};

export default ImportFlowModal;
